<template>
  <v-btn
    variant="text"
    icon
    density="compact"
    :size="size"
    @click="copyToClipboard(copyText)"
  >
    <v-icon icon="mdi-content-copy" v-if="!isShowTooltip" />
    <v-icon icon="mdi-check-bold" style="color:#43A047;" v-if="isShowTooltip" />
    <v-tooltip
      v-model="isShowTooltip"
      activator="parent"
      :open-on-hover="false"
      location="bottom"
      :update:modelValue="false"
      >コピーしました</v-tooltip
    ></v-btn
  >
</template>
<script setup lang="ts">
import { ref } from 'vue';

type Size = 'x-small' | 'small' | 'default' | 'large' | 'x-large';
const props = withDefaults(defineProps<{ copyText: string; size: Size }>(), {
  size: 'default',
});
const isShowTooltip = ref(false);
const prevTimeoutId = ref(0);

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
  showTooltip();
};

const showTooltip = () => {
  isShowTooltip.value = true;
  clearTimeout(prevTimeoutId.value);
  prevTimeoutId.value = setTimeout(() => {
    isShowTooltip.value = false;
  }, 2000);
};
</script>
<style lang="scss" scoped>
.copy-element {
  display: flex;
  cursor: pointer;
}
</style>
